export const LD_EXCEL_SHEET_NAMES = {
    SUMMARY_ASSUMPTIONS: 'Summary & Assumptions',
    DEVELOPMENT_BUDGET: 'Development Budget',
    DISPOSITION: 'Disposition',
    CASH_FLOW: 'Cash Flow Schedule',
    RETURNS_SUMMARY: 'Returns Summary',
} as const;

export const LD_LABELS = {
    summary: {
        projectInfo: 'PROJECT INFO',
        keyDates: 'KEY DATES',
        address: 'Address',
        siteAcreage: 'Site acreage',
        totalLots: 'Total lots',
        lotWidthRange: 'Lot width range',
        analysisStart: 'Analysis start',
        constructionStart: 'Construction start',
        constructionDuration: 'Construction duration',
        salesStart: 'Sales start',
        selloutDate: 'Sellout date',
        holdPeriod: 'Hold period',
    },
    developmentBudget: {
        title: 'Development Budget (Sources & Uses)',
        usesHeader: 'DEVELOPMENT BUDGET (USES)',
        amount: 'Amount',
        costPerLot: 'Cost / Lot',
        costPerFf: 'Cost / FF',
        totalDevelopmentCost: 'TOTAL DEVELOPMENT COST',
        sourcesHeader: 'SOURCES OF CAPITAL',
        percentOfTotal: '% of Total',
        rateTerms: 'Rate / Terms',
        totalSources: 'TOTAL SOURCES',
    },
    disposition: {
        salesAssumptions: 'SALES ASSUMPTIONS',
        pricingByLotType: 'PRICING BY LOT TYPE',
        lotTakedownByType: 'LOT TAKEDOWN BY TYPE',
        otherRevenue: 'OTHER REVENUE',
        otherRevenueSubtotal: 'Subtotal other revenue',
        revenueSummary: 'REVENUE SUMMARY',
        revenueSummaryAmount: 'Amount',
        grossSaleProceeds: 'Total sale proceeds (gross)',
        closingCosts: 'Closing costs',
        netSaleProceeds: 'Net sale proceeds',
        otherRevenueLine: 'Other revenue',
        totalNetRevenue: 'TOTAL NET REVENUE',
        annualLotTakedown: 'ANNUAL LOT TAKEDOWN',
        salesStart: 'Sales start',
        closingCostsPercent: 'Closing costs',
        priceEscalation: 'Annual price escalation',
        saleFrequency: 'Sale frequency',
        lotType: 'Lot type',
        lotSize: 'Width (ft)',
        numberOfLots: 'Lots',
        costPerFrontFoot: 'Price / FF',
        pricePerLot: 'Price / Lot',
        grossProceeds: 'Gross Proceeds',
        firstSale: 'First sale',
        totalLots: 'Total lots',
        initialTake: 'Initial take',
        recurring: 'Recurring',
        description: 'Description',
        date: 'Date',
        amount: 'Amount',
        blended: 'Total / blended',
        year: 'Year',
        lotsSold: 'Lots sold',
        revenue: 'Revenue',
        annualGrossSaleProceeds: 'Gross sale proceeds',
    },
    cashFlow: {
        title: 'Cash Flow Schedule',
        developmentBudget: 'DEVELOPMENT BUDGET',
        totalDevelopmentCosts: 'Total development costs',
        constructionFinancing: 'CONSTRUCTION FINANCING',
        loanDraws: 'Construction loan draws',
        interest: 'Construction loan interest',
        financingFees: 'Financing fees',
        constructionLoanPayoff: 'Construction loan payoff',
        saleProceeds: 'SALE PROCEEDS',
        netSaleProceeds: 'Net sale proceeds',
        netLeveredCashFlow: 'NET LEVERED CASH FLOW',
    },
    returns: {
        title: 'Returns Summary',
        projectReturns: 'PROJECT RETURNS',
        projectEconomics: 'PROJECT ECONOMICS',
        keyStatistics: 'KEY STATISTICS',
        metric: 'Metric',
        unlevered: 'Unlevered',
        levered: 'Levered',
        irr: 'Net IRR',
        equityMultiple: 'Equity multiple',
        roi: 'ROI',
        netProfit: 'Net profit',
        projectProfit: 'Project profit',
        projectProfitMargin: 'Project profit margin (on cost)',
        profitPerLot: 'Profit per lot',
        totalDevelopmentCost: 'Total development cost',
        totalNetRevenue: 'Total net revenue',
        netSaleProceeds: 'Net sale proceeds',
        otherRevenue: 'Other revenue',
        totalEquity: 'Total equity',
        constructionLoan: 'Construction loan',
    },
} as const;
